import React from "react";
import { Quote, Star } from "lucide-react";
import { SHOP } from "@/constants/testIds";

const reviews = [
  {
    id: "rv-rajesh",
    name: "Rajesh Kumar",
    role: "Electrical Contractor",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    quote:
      "Adeshwar delivered 200m of Polycab wire in 45 minutes. Genuine, QR-verified, and 22% cheaper than my local supplier. Permanent customer now.",
    rating: 5,
  },
  {
    id: "rv-priya",
    name: "Priya Sharma",
    role: "Homeowner, Bangalore",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    quote:
      "Renovated my flat and ordered all switches, lights and fans from Adeshwar. Delivery was super-fast and prices beat every other store.",
    rating: 5,
  },
  {
    id: "rv-iqbal",
    name: "Mohammed Iqbal",
    role: "Builder, Whitefield",
    avatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80",
    quote:
      "Bulk pricing on MCBs and conduits is unbeatable. I now use Adeshwar for all my projects. Their delivery team is professional and prompt.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section data-testid={SHOP.testimonials} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-14 sm:mt-20">
      <div className="text-center mb-8 sm:mb-12">
        <div className="text-[10px] sm:text-xs uppercase tracking-[0.22em] text-[#0056D2] font-bold">
          Customers love Adeshwar
        </div>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black text-gray-900 mt-1 tracking-tight">
          Trusted by 50,000+ contractors & homeowners
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-5 sm:gap-6">
        {reviews.map((r) => (
          <div
            key={r.id}
            className="relative bg-white border border-gray-200 rounded-2xl p-6 sm:p-7 hover:shadow-lg hover:-translate-y-1 transition-all duration-200"
          >
            <Quote className="absolute top-5 right-5 text-[#FFD700]" size={32} />
            <div className="flex items-center gap-1 mb-3">
              {Array.from({ length: r.rating }).map((_, j) => (
                <Star key={`${r.id}-star-${j}`} size={16} className="text-[#FFD700] fill-[#FFD700]" />
              ))}
            </div>
            <p className="text-sm sm:text-base text-gray-800 leading-relaxed">{r.quote}</p>
            <div className="mt-5 flex items-center gap-3">
              <img src={r.avatar} alt={r.name} className="w-10 h-10 rounded-full object-cover border border-gray-200" />
              <div>
                <div className="text-sm font-bold text-gray-900">{r.name}</div>
                <div className="text-xs text-gray-600">{r.role}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
